import { loadingStyles } from '@/src/card-linking/components/iframeStyles'

export const CardLinkLoader = () => {
    return <p style={loadingStyles}>Loading...</p>
}

export default CardLinkLoader
